import { apiRequest } from "./client";

function endpoint(projectId) {
  return `/projects/${encodeURIComponent(projectId)}/tag-manager`;
}

export const tagManagerApi = {
  get(projectId) {
    return apiRequest(endpoint(projectId));
  },
  save(projectId, config) {
    return apiRequest(endpoint(projectId), { method: "PUT", body: JSON.stringify(config) });
  },
  remove(projectId) {
    return apiRequest(endpoint(projectId), { method: "DELETE" });
  },
};
